<template>
    <div class="card p-3 px-2 px-lg-6">
        <slot name="heading">
            <h2 class="t-orange ml-12px mb-3">Change your password</h2>
        </slot>

        <div style="padding: 0 12px 12px;">
            <div v-if="updated" class="alert alert-success">Password updated successfully.</div>
            <div v-if="errors && !Array.isArray(errors)" class="alert alert-error">{{ errors[Object.keys(errors)[0]][0] }}</div>
        </div>

        <form method="POST" action="#" class="form">
            <div v-if="errors && Array.isArray(errors)" class="errors mb-4">
                <template v-for="(field) in errors">
                    <div v-for="(error) in field" class="error">{{error}}</div>
                </template>
            </div>
            <div class="account-details d-flex flex-column justify-content-center">
                <div class="columns">
                    <div class="column is-half">
                        <div class="field mb-5" :class="{ 'has-error': $v.form.currentPassword.$error }">
                            <label class="label mb-1" for="currentPassword">Current Password*</label>
                            <div class="control">
                                <input id="currentPassword" name="password_confirmation" class="input"
                                       type="password" v-model.trim="$v.form.currentPassword.$model"/>
                            </div>
                            <div class="error" v-if="$v.$dirty && $v.form.currentPassword.$error">
                                {{getErrorMessage($v.form.currentPassword)}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns mb-2">
                    <div class="column is-half">
                        <div class="field mb-5" :class="{ 'has-error': $v.form.password.$error }">
                            <label class="label mb-1" for="password">New Password*</label>
                            <div class="control">
                                <input id="password" name="password" class="input" type="password"
                                       v-model.trim="$v.form.password.$model">
                            </div>
                            <div class="error" v-if="$v.$dirty && $v.form.password.$error">
                                {{getErrorMessage($v.form.password)}}
                            </div>
                        </div>
                    </div>
                    <div class="column is-half">
                        <div class="field mb-5" :class="{ 'has-error': $v.form.passwordConfirmation.$error }">
                            <label class="label mb-1" for="passwordConfirmation">Confirm New Password*</label>
                            <div class="control">
                                <input id="passwordConfirmation" name="password_confirmation" class="input"
                                       type="password" v-model.trim="$v.form.passwordConfirmation.$model"/>
                            </div>
                            <div class="error" v-if="$v.$dirty && $v.form.passwordConfirmation.$error">
                                {{getErrorMessage($v.form.passwordConfirmation)}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field d-md-flex justify-content-end px-2 mb-2">
                    <button v-if="!loading" @click.prevent="submit()" class="btn btn-form">
                        Change password
                    </button>
                    <pulse-loader v-if="loading" :loading="true" :color="'#E57722'"
                                  :size="'20px'"></pulse-loader>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import SettingsSidebar from '../../shared/SettingsSidebar';
    import {mapGetters} from "vuex";
    import {axiosWeb} from "@/js/axios";
    import {required, sameAs} from 'vuelidate/lib/validators';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

    export default {
        name: 'CatUxoProfileChangePassword',
        components: {
            SettingsSidebar,
            PulseLoader,
        },
        props: {
            user: {
                type: Object,
                required: true
            },
            redirectTo: {
                type: String,
                required: false
            }
        },
        data: function () {
            return {
                form: {
                    csrfToken: null,
                    userId: this.user.id,
                    currentPassword: null,
                    password: null,
                    passwordConfirmation: null,
                },
                loading: false,
                errors: [],
                updated: null,
            }
        },
        computed: {
            ...mapGetters('form', [
                'getErrorMessage'
            ]),
            rules() {
                return {
                    currentPassword: {
                        required,
                    },
                    password: {
                        required,
                    },
                    passwordConfirmation: {
                        required,
                        sameAsPassword: sameAs('password')
                    },
                }
            },
        },
        methods: {
            submit() {
                let $this = this;
                $this.$v.form.$touch();
                if ($this.$v.form.$invalid) return;

                $this.errors = [];

                // Display the loading on the button
                $this.loading = true;

                // Subscribe the user
                return axiosWeb.post(`/api/v1/change-password/${$this.user.id}`, $this.form).then(response => {
                    $this.loading = false;

                    if (response.status === 200) {
                        $this.updated = true;
                        setTimeout(() => this.updated = false, 3000);
                        window.location.href = '/'
                    }

                }).catch((error) => {
                    $this.loading = false;

                    if (error.response.status === 422) {
                        $this.errors = error.response.data.errors;
                    }

                    if (error.response.status === 500) {
                        $this.errors = error.response.data.errors;
                        setTimeout(() => this.errors = false, 3000);
                    }
                })
            }
        },
        created() {
            this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        },
        validations() {
            return {
                form: this.rules
            }
        },
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>
    @include media-breakpoint-down(sm) {
        .btn,
        .btn-form {
            width: 100%;
            max-width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/pages/settings/ChangePassword.vue